import { render, staticRenderFns } from "./DataListjobRiskAssessments.vue?vue&type=template&id=30098638&scoped=true&"
import script from "./DataListjobRiskAssessments.vue?vue&type=script&lang=js&"
export * from "./DataListjobRiskAssessments.vue?vue&type=script&lang=js&"
import style0 from "./DataListjobRiskAssessments.vue?vue&type=style&index=0&id=30098638&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30098638",
  null
  
)

export default component.exports